module.exports = __webpack_public_path__ + "img/b_7.00568099.jpg";